import ApiService from "./ApiService"; 

export async function apiGetSubscriptionLeftList(partnerId) {
  return ApiService.fetchData({
    url: `b2b-subscriptions?filters[partner][id][$eq]=${partnerId}`,
    method: "GET",
  });
}
export async function apiGetWaitingList(partnerId,reqStatus,farmassitId=null) {
  console.log("farmassitId",farmassitId)
  let url = `b2b-waitings?filters[status][$eq]=${reqStatus}&filters[partner][id][$eq]=${partnerId}`;
  if (farmassitId) {
    url += `&filters[farmasist_user][id][$eq]=${farmassitId}`;
  }
  return ApiService.fetchData({
    url: url,
    method: "GET",
  });
}
export async function apiGetCompleteSubscriptionList({partnerId,to,from}) {

  return ApiService.fetchData({
    url: `b2b/complete-subscrpition?partnerId=${partnerId}&to=${to}&from=${from}`,
    method: "GET",
  });
}
export async function apiGetPaymentHistory(partnerId) {
  return ApiService.fetchData({
    url: `payements?filters[partner][id][$eq]=${partnerId}`,
    method: "GET",
  });
}

export async function apiUpdateAllowedSubscription(id,data) {
  return ApiService.fetchData({
    url: `b2b-subscriptions/${id}`,
    data: data,
    method: "PUT",
  });
}

export async function apiGetPromoterCreditList(partnerId) {
  return ApiService.fetchData({
    url: `promoter-credits?populate[userId][fields][0]=name&filters[partnerId]=${partnerId}`,
    method: "GET",
  });
}
export async function apiPostPromoterCredit(data) {
  return ApiService.fetchData({
    url: `/b2b/promoter-credits/action`,
    data: data,
    method: "POST",
  });
}
